import { CALL_QUEUES, MAX_MEMBERS_PER_ROW, RING_GROUPS } from "./constants";
import { getColumnDef } from "@/react/schema/schemaFields";
import { TYPES } from "@/react/components/table";
import ExtensionsSelect from "@/react/features/smp/cells/ExtensionsSelect";
import MemberExistsCell from "@/react/features/smp/cells/MemberExistsCell";

const rgcqMemberColumnsGenerator = (schema, type) => {
  const members = [];
  for (let index = 0; index < MAX_MEMBERS_PER_ROW; index++) {
    members.push(
      {
        ...getColumnDef(
          schema.fields[`members[${index}].isActive`],
          `Member ${index + 1} Active`
        ),
        editableCell: MemberExistsCell,
        type: TYPES.BOOLEAN,
        editable: true,
        accessorFn: (row) => row.members && row.members[index]?.isActive,
        minSize: 200,
      },
      {
        ...getColumnDef(
          schema.fields[`members[${index}].memberVoiceMailAccess`],
          `Member ${index + 1} Voice Mail Access`
        ),
        editable: true,
        type: TYPES.BOOLEAN,
        accessorFn: (row) =>
          row.members && row.members[index]?.memberVoiceMailAccess,
      },
      ...(type === CALL_QUEUES
        ? [
            {
              ...getColumnDef(
                schema.fields[`members[${index}].isPrimary`],
                `Member ${index + 1} Is Primary`
              ),
              editable: true,
              type: TYPES.SELECT,
              options: { true: "true", false: "false" },
              accessorFn: (row) => row.members && row.members[index]?.isPrimary,
            },
          ]
        : []),
      ...(type === RING_GROUPS
        ? [
            {
              ...getColumnDef(
                schema.fields[`members[${index}].memberSequenceNumber`],
                `Member ${index + 1} Sequence Number`
              ),
              editable: true,
              accessorFn: (row) =>
                row.members && row.members[index]?.memberSequenceNumber,
            },
          ]
        : []),
      {
        ...getColumnDef(
          schema.fields[`members[${index}].memberExtensionNumber`],
          `Member ${index + 1} Extension Number`
        ),
        editable: true,
        editableCell: ExtensionsSelect,
        accessorFn: (row) =>
          row.members && row.members[index]?.memberExtensionNumber,
      }
    );
  }
  return members;
};

export default rgcqMemberColumnsGenerator;
